// Guide interactif (D-091) : ce que la base sait des premiers pas de chacun. Les règles sont dans la
// base (migration 20261028150000_guide.sql) : on ne lit que ses propres pas, la console seule voit
// l'activation de tous les clubs.
import { supabase } from './supabase';
import type { GuideRole } from '../guide/steps';

const db = () => {
  if (!supabase) throw new Error('Base non configurée');
  return supabase;
};

export interface StepState { key: string; done: boolean; n?: number; team?: string; slug?: string | null }
/** `optional` (bureau, D-122) : les étapes facultatives (« quand tu veux ») : le reste du bureau, la page du club. */
export interface OnboardingState { club_id: string; demo: boolean; created_at: string; roles: { role: GuideRole; steps: StepState[]; optional?: StepState[] }[] }

/** Mes premiers pas dans ce club, rôle par rôle ; null hors de mes clubs (ou base sans le guide). */
export async function onboardingState(clubId: string): Promise<OnboardingState | null> {
  const { data, error } = await db().rpc('onboarding_state', { p_club: clubId });
  if (error) throw new Error(error.message);
  return (data ?? null) as OnboardingState | null;
}

/** Un pas vu par l'appareil : app posée sur l'écran d'accueil, visibilité vue, « comment répondre » vu. */
export async function guideMark(clubId: string, step: 'ecran' | 'visibilite' | 'repondre'): Promise<void> {
  const { error } = await db().rpc('guide_mark', { p_club: clubId, p_step: step });
  if (error) throw new Error(error.message);
}

/** « Ce tuto t'a aidé ? » (la dernière réponse compte). */
export async function guideFeedback(slug: string, helpful: boolean, clubId: string | null): Promise<void> {
  const { error } = await db().rpc('guide_feedback', { p_slug: slug, p_helpful: helpful, p_club: clubId });
  if (error) throw new Error(error.message);
}

export interface ActivationRow {
  id: string; name: string; created_at: string; steps: StepState[]; last_step_at: string | null; nudges: number;
  last_nudge_at: string | null; last_nudge_step: string | null; accounts: number; support: number; support_open: number;
}
/** Console : l'activation des clubs récents (admins de la plateforme seulement). */
export async function consoleActivation(): Promise<ActivationRow[]> {
  const { data, error } = await db().rpc('console_activation');
  if (error) throw new Error(error.message);
  return (data ?? []) as ActivationRow[];
}
